import { useState } from "react";
import { Share2, Copy, MessageCircle, Check } from "lucide-react";
import { toast } from "sonner";

function Twitter({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
    </svg>
  );
}
function Facebook({ size = 16 }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor"><path d="M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z"/></svg>;
}
function Telegram({ size = 16 }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>;
}

export default function ShareButtons({ url, title, vertical = false, compact = false }) {
  const [copied, setCopied] = useState(false);
  const fullUrl = url.startsWith("http") ? url : `${window.location.origin}${url}`;
  const enc = encodeURIComponent;

  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, url: fullUrl });
        return;
      } catch (err) { console.debug("[popu] cancelled", err); }
    }
    copy();
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(fullUrl);
      setCopied(true);
      toast.success("Link copiado");
      setTimeout(() => setCopied(false), 1500);
    } catch (_) {
      toast.error("No se pudo copiar");
    }
  };

  const links = [
    { id: "whatsapp", label: "WhatsApp", color: "#25D366", href: `https://wa.me/?text=${enc(title + " " + fullUrl)}`, icon: <MessageCircle size={compact ? 14 : 16} /> },
    { id: "x", label: "X", color: "#000", href: `https://twitter.com/intent/tweet?text=${enc(title)}&url=${enc(fullUrl)}`, icon: <Twitter size={compact ? 14 : 16} /> },
    { id: "facebook", label: "Facebook", color: "#1877F2", href: `https://www.facebook.com/sharer/sharer.php?u=${enc(fullUrl)}`, icon: <Facebook size={compact ? 14 : 16} /> },
    { id: "telegram", label: "Telegram", color: "#26A5E4", href: `https://t.me/share/url?url=${enc(fullUrl)}&text=${enc(title)}`, icon: <Telegram size={compact ? 14 : 16} /> },
  ];

  return (
    <div className={`flex ${vertical ? "flex-col" : "flex-wrap"} items-center gap-2`} data-testid="share-buttons">
      {links.map((l) => (
        <a
          key={l.id}
          href={l.href}
          target="_blank"
          rel="noreferrer"
          aria-label={`Compartir en ${l.label}`}
          data-testid={`share-${l.id}`}
          className={`${compact ? "w-8 h-8" : "w-10 h-10"} rounded-full flex items-center justify-center text-white hover:opacity-85 transition`}
          style={{ background: l.color }}
        >
          {l.icon}
        </a>
      ))}
      <button
        onClick={copy}
        aria-label="Copiar link"
        data-testid="share-copy"
        className={`${compact ? "w-8 h-8" : "w-10 h-10"} rounded-full border flex items-center justify-center hover:accent-border hover:accent-text transition`}
        style={{ borderColor: "var(--border)", color: "var(--text)" }}
      >
        {copied ? <Check size={compact ? 14 : 16} /> : <Copy size={compact ? 14 : 16} />}
      </button>
      <button
        onClick={share}
        aria-label="Compartir"
        data-testid="share-native"
        className={`${compact ? "w-8 h-8" : "w-10 h-10"} rounded-full accent-bg text-white flex items-center justify-center hover:opacity-90 transition`}
      >
        <Share2 size={compact ? 14 : 16} />
      </button>
    </div>
  );
}
